import { cn } from '../utils';
import config from '../config';

/**
 * Dimora brand mark: an arched doorway under a roofline.
 */
export function LogoMark({ className, title = 'Dimora' }) {
  return (
    <svg
      viewBox="0 0 64 64"
      role="img"
      aria-label={title}
      className={cn('shrink-0', className)}
    >
      <path
        d="M20 52V32a12 12 0 0 1 24 0v20"
        fill="none"
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
      />
      <path
        d="M13 32 32 14l19 18"
        fill="none"
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="38" cy="41" r="2.6" fill="currentColor" />
    </svg>
  );
}

/**
 * Brand mark + wordmark. `size` drives both.
 */
export default function Logo({ className, size = 'md', showName = true }) {
  const markSize =
    size === 'lg' ? 'size-12' : size === 'sm' ? 'size-6' : 'size-8';
  const textSize =
    size === 'lg' ? 'text-4xl' : size === 'sm' ? 'text-base' : 'text-xl';

  return (
    <div className={cn('flex items-center gap-2.5', className)}>
      <LogoMark className={cn(markSize, 'text-primary')} />
      {showName ? (
        <span className={cn('dimora-wordmark', textSize)}>
          {config.APP_NAME || 'Dimora'}
        </span>
      ) : null}
    </div>
  );
}
